import React, { Suspense } from "react";
import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";

// internal
import './App.css';
import {lightTheme} from "./themes";
import HomeScreen from "./screens";
import Course from "./screens/Course";
import AdvancedSampleInput from "./screens/SampleInput/Advanced";
import SimpleSampleInput from "./screens/SampleInput/Simple";
import Agreement from "./screens/Agreement";
import Documentation from "./screens/Document";
import AgreementList from "./screens/AgreementList";
import Initialize from "./screens/init";

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={lightTheme}>
        <RecoilRoot>
          <Router>
            <Initialize />
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/simple-sample-input" element={<SimpleSampleInput />} />
                <Route path="/advanced-sample-input" element={<AdvancedSampleInput />} />
                <Route path="/course/:id" element={<Course />} />
                <Route path="/agreement/:id" element={<Agreement />} />
                <Route path="/document/:id" element={<Documentation isFinal={true} />} />
                <Route path="/agreements" element={<AgreementList />} />
                <Route path="/" element={<HomeScreen />} />
              </Routes>
            </Suspense>
          </Router>
        </RecoilRoot>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
